import React, { useState } from 'react';
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col, Accordion, Modal, Button, Form } from "react-bootstrap";
// import Carousel from 'react-bootstrap/Carousel';

function Jobs() {

  // useEffect(()=>{
  //     document.title = 'Elixir | Our Jobs';
  //   }, []);

  
  // Modal with Form Start
  const [show, setShow] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    company: "",
    message: "",
    resume: null,
  });

  const handleShow = (jobTitle) => {
    setSelectedJob(jobTitle);
    setFormData((prev) => ({ ...prev, company: jobTitle }));
    setShow(true);
  };

  const handleClose = () => setShow(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Handle form submission logic here (e.g., API call)
    handleClose(); // Close modal after submit
  };
  // Modal with Form End

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Our Jobs</span></h1>
                <h4>Join Elixir Advertising: Innovate, Grow, Succeed</h4>
              </div>
              <div className="innerPages-box4">   
              <div className="contactMap-text">
                <h3>Join Our Team</h3>
                <p>At Elixir & AR Graphics, we believe in talent, innovation, and growth. We’re always looking for passionate, skilled, and motivated professionals to join our team and help us deliver exceptional solutions and services across advertising, IT, branding, and more.</p>
                <p>If you’re eager to grow your career, work on exciting projects, and be part of a dynamic team, explore our opportunities and become a part of our journey in Saudi Arabia and the Middle East.</p>
                </div>  
              </div>
            </Col>
            <Col lg={9}>
            <div className="projectPages-box5">               
                  <div className="jobBox">
                    <h4>Be Part of Our Company</h4>
                    <Accordion defaultActiveKey="">

                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>1. Graphic Designer</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing Industry, Proficiency in Adobe Creative Suite</p>
                            <p><span>Tool:</span> Photoshop, Illustrator, CorelDraw</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>                        

                        <Accordion.Body>
                        <div className="jobListing">
                          <h6>Job Description</h6>
                          <p>
                          <strong>Are you a creative powerhouse with a passion for design?</strong> Join our dynamic team and help shape visual experiences that make an impact. From social media graphics to print materials, we’re looking for someone who can bring ideas to life with style and precision.
                          </p>
                          <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                        </div>
                        </Accordion.Body>                        

                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>2. Sales & Marketing Executive</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing, Trading Industry</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p>
                            <strong>Are you a results-driven professional with a flair for communication and business growth?</strong> We’re looking for an energetic <b>Sales & Marketing Executive</b> to promote our wide range of services and drive new opportunities
                            </p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>3. Business Development Manager</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing, Trading Industry</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p><strong>Are you a strategic thinker with a passion for growth?</strong> We’re seeking a <b>Business Development Manager</b> to drive expansion, build partnerships, and lead initiatives that take our business to the next level.</p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="4">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>4. Production Supervisor</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing, Trading Industry</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p><strong>Are you a hands-on leader with experience in production management?</strong> We're looking for a <b>Production Supervisor</b> to oversee and optimize daily operations across our signage, printing, fabrication, and installation units.</p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="5">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>5. Large Format Printing machine Acylic Cutting machine cutting sticker technician</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing, Trading Industry</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p>We are looking for a <b>multi-skilled technician</b> who specializes in operating and maintaining <b>Large Format Printing Machines, Acrylic Cutting Machines, and Cutting Sticker Equipment</b>.</p>
                            <p>If you're experienced with machines like <b>Mimaki, Roland, CNC routers, laser cutters, and vinyl plotters</b>, we want to work with you!</p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="6">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>6. 3D Letter Making Technician</h5>
                            <p><span>Industry:</span> Prepress, Signage, Printing, Trading Industry</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p>We’re looking for a <b>skilled and experienced 3D Letter Making Technician</b> to join our signage production team. If you know how to fabricate acrylic, metal, and LED 3D letters with precision and creativity <strong>— We want you on board!</strong></p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="7">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>7. Web & Graphic Designer</h5>
                            <p><span>Industry:</span> Advertising, Web Designing Company, Digital Marketing Company</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p>We’re looking for a <b>creative, versatile, and tech-savvy designer</b> who can handle both <b>web design</b> and <b>graphic design</b> projects. If you have an eye for clean layouts, understand user experience, and can create eye-catching graphics <strong>— We want to hear from you!</strong></p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="8">
                        <Accordion.Header>
                          <div className="jobListing">
                            <h5>8. Digital Marketing Specialist</h5>
                            <p><span>Industry:</span> Advertising, Web Designing Company, Digital Marketing Company</p>
                            <div className="lable">
                              <span>3 + Year</span>
                              <span>Full Time</span>
                              <span>Saudi Arabia – Al Khobar</span>
                            </div>
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="jobListing">
                            <h6>Job Description</h6>
                            <p>We are seeking a <b>Digital Marketing Specialist</b> to join our dynamic team. If you're passionate about driving business growth through effective <b>SEO, SEM, content strategy,</b> and <b>social media</b>.</p>
                            <a href='mailto:jobs@elixirworldwide.com' className="applyBtn">Apply</a>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                    </Accordion>
                  </div>
                </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Jobs;
